import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Helmet } from "react-helmet";
import GradeIcon from "@mui/icons-material/Grade";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { addProductImg } from "../../Reducers/authReducer";
import { useGetStoreDealsQuery } from "../../services/search";
import formatPrice from "../../Components/formatPrice";
import ProductCountries from "../../Components/Header/ProductCountries";
import Host from "../../Components/Host";
import { storeIds } from "../../constants/storeIds";

const STYLES = `
 
  .sd-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    padding: 14px 0 12px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 14px;
  }

  .sd-page-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 1.15rem;
    font-weight: 700;
    color: #111;
  }

  /* Search input */
  .sd-search-box {
    position: relative;
    width: 280px;
    max-width: 100%;
  }
  .sd-search-input {
    width: 100%;
    height: 40px;
    padding: 0 40px 0 14px;
    border: 1.5px solid #e0e0e0;
    border-radius: 22px;
    font-size: 0.85rem;
   
    outline: none;
    transition: border-color 0.15s;
    background: #fafafa;
  }
  .sd-search-input:focus { border-color: #1a73e8; background: #fff; }
  .sd-search-btn {
    position: absolute;
    top: 50%; right: 6px;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #666;
    display: flex;
    padding: 4px;
  }

 
  .sd-mobile-bar {
    display: none;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0 10px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 8px;
  }
  .sd-filter-toggle {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 7px 14px;
    border-radius: 20px;
    border: 1.5px solid #ddd;
    background: #fff;
    font-weight: 600;
    font-size: 0.82rem;
    cursor: pointer;
    color: #333; 
  }

 
  .sd-layout {
    display: flex;
    gap: 20px;
    align-items: flex-start;
  }

 
  .sd-sidebar {
    width: 210px;
    flex-shrink: 0;
    position: sticky;
    top: 80px;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    padding-right: 4px;
  }
  .sd-filter-section {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f3f3f3;
  }
  .sd-filter-section:last-child { border-bottom: none; }
  .sd-filter-heading {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #aaa;
    margin: 0 0 9px 0;
  }
  .sd-pill-group { display: flex; flex-wrap: wrap; gap: 6px; }
  .sd-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 20px;
    border: 1.5px solid #ddd;
    font-size: 0.78rem;
    font-weight: 500;
    color: #555;
    background: #fafafa;
    cursor: pointer;
    text-decoration: none;
    transition: border-color 0.15s, background 0.15s;
  }
  .sd-pill.active { border-color: #1a73e8; background: #e8f0fe; color: #1a73e8; }
  .sd-pill img { width: 16px; object-fit: contain; }
  .sd-brand-pill {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
    border: 1px solid #e8e8e8;
    font-size: 0.73rem;
    font-weight: 500;
    color: #555;
    background: #f9f9f9;
    cursor: pointer;
    text-decoration: none;
  }
  .sd-show-more {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    color: #1a73e8;
    padding: 6px 0 0;
    display: flex;
    align-items: center;
    
  }

 
  .sd-main { flex: 1; min-width: 0; }

 
  .sd-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 13px;
  }

 
  .sd-card-link { text-decoration: none; color: inherit; }
  .sd-card {
    position: relative;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    overflow: hidden;
    transition: box-shadow 0.2s, transform 0.2s;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .sd-card:hover { box-shadow: 0 6px 22px rgba(0,0,0,0.10); transform: translateY(-2px); }

  .sd-img-wrap {
    width: 100%;
    height: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff0;
    padding: 10px;
    position: relative;
    overflow: hidden;
        align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 50%;
    position: relative;
    height: 215px;
  }
  .sd-img-wrap img,
  .sd-img-wrap span img { 
  max-width: 100%;
 
  object-fit: contain;
  height: 215px;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    position: relative;
    z-index: 2;
  }

  .sd-card-body {
    padding: 9px 11px 12px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .sd-card-title {
    font-size: 0.78rem;
    font-weight: 500;
    color: #222;
    line-height: 1.35;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 34px;
  }
  .sd-meta { display: flex; align-items: center; justify-content: space-between; gap: 4px; margin-top: 2px; }
  .sd-brand { font-size: 0.68rem; color: #aaa; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 60%; }
  .sd-rating {
    display: inline-flex; align-items: center; gap: 2px;
    font-size: 0.68rem; font-weight: 600; color: #666;
    background: #fff8f2; border: 1px solid #ffe4cc;
    border-radius: 20px; padding: 2px 6px; white-space: nowrap;
  }
  .sd-price-row { display: flex; align-items: baseline; gap: 5px; flex-wrap: wrap; margin-top: 3px; }
  .sd-deal-price { font-size: 0.92rem; font-weight: 700; color: #111; line-height: 1.2; }
  .sd-orig-price { font-size: 0.7rem; color: #bbb; text-decoration: line-through; }
  .sd-origin { display: flex; align-items: center; gap: 4px; margin-top: auto; padding-top: 5px; }
  .sd-from { font-size: 0.67rem; color: #bbb; }
  .sd-flag { width: 15px; object-fit: contain; }

  .sd-deal-badge {
    position: absolute; top: 7px; left: 7px;
    background: #ff4757; color: #fff;
    font-size: 0.58rem; font-weight: 700;
    padding: 2px 6px; border-radius: 4px; z-index: 2;
    text-transform: uppercase; letter-spacing: 0.04em;
  }
  .sd-flash-badge {
    position: absolute; top: 7px; right: 7px;
    background: #ff4757; color: #fff;
    border-radius: 50%; width: 22px; height: 22px;
    display: flex; align-items: center; justify-content: center; z-index: 2;
  }
  .sd-fast-delivery {
    position: absolute; bottom: 6px; left: 0; right: 0;
    display: flex; justify-content: center;
  }
  .sd-fast-delivery span {
    display: inline-flex; align-items: center; gap: 3px;
    font-size: 0.62rem; font-weight: 600; color: #fe7f4a;
    background: rgba(255,255,255,0.92); padding: 2px 7px;
    border-radius: 20px; border: 1px solid #ffe4cc;
  }

 
  .sd-overlay { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.4); z-index: 1000; }
  .sd-overlay.open { display: block; }
  .sd-drawer {
    position: fixed; top: 0; left: 0;
    width: 280px; height: 100vh;
    background: #fff; z-index: 1001;
    overflow-y: auto;
    box-shadow: 4px 0 20px rgba(0,0,0,0.13);
    transform: translateX(-100%);
    transition: transform 0.28s cubic-bezier(.4,0,.2,1);
    padding: 0 16px 40px;
  }
  .sd-drawer.open { transform: translateX(0); }
  .sd-drawer-head {
    display: flex; align-items: center; justify-content: space-between;
    padding: 16px 0 10px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 12px;
  }

  
  .sd-load-more-wrap {
    display: flex; justify-content: center;
    margin-top: 28px;
  }
  .sd-load-more-btn {
    display: flex; align-items: center; gap: 8px;
    padding: 10px 32px;
    border-radius: 24px;
    border: 1.5px solid #ddd;
    background: #fff;
    font-size: 0.875rem;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .sd-load-more-btn:hover:not(:disabled) { border-color: #1a73e8; color: #1a73e8; box-shadow: 0 2px 10px rgba(26,115,232,0.12); }
  .sd-load-more-btn:disabled { opacity: 0.5; cursor: not-allowed; }

 
  @keyframes sd-shimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  .sd-skel {
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: sd-shimmer 1.4s infinite;
    border-radius: 6px;
  }

 
  .sd-empty {
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; gap: 10px;
    padding: 60px 20px;
    color: #aaa;
    text-align: center;
  }
  .sd-empty svg { font-size: 2.5rem !important; }
  .sd-empty p { font-size: 0.9rem; color: #888; max-width: 280px; }

 
  @media (max-width: 768px) {
    .sd-mobile-bar { display: flex; }
    .sd-sidebar { display: none; }
    .sd-layout { gap: 0; }
    .sd-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 10px; }
    .sd-img-wrap { height: 140px; }
    .sd-page-header { flex-direction: column; align-items: flex-start; }
    .sd-search-box { width: 100%; }
    .sd-page-title { font-size: 1rem; }
  }
  @media (max-width: 380px) {
    .sd-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 8px; }
    .sd-img-wrap { height: 120px; padding: 6px; }
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    .sd-grid { grid-template-columns: repeat(3, 1fr); }
  }
`;

function functionIdLink(id, pid, store_id) {
  return storeIds?.includes(Number(store_id)) ? pid : id;
}

function productTitle(title) {
  return title
    ?.replace(/[^A-Za-z0-9]/g, " ")
    ?.replace(/[^\w\s]/gi, " ")
    ?.replace(/ /g, "-");
}

function ratingFucn(r) {
  return r && r !== 0 && r !== "0";
}

const handleImgError = (e) => {
  e.target.src = "https://cdn.ebtida.com/1705315901965-Image-not-found.jpg";
};

function SkeletonGrid({ count = 8 }) {
  return (
    <div className="sd-grid">
      {[...Array(count)].map((_, i) => (
        <div
          key={i}
          style={{ borderRadius: 12, border: "1px solid #f0f0f0", overflow: "hidden", background: "#fafafa" }}
        >
          <div className="sd-skel" style={{ width: "100%", height: 168 }} />
          <div style={{ padding: 12 }}>
            <div className="sd-skel" style={{ height: 10, width: "90%" }} />
            <div className="sd-skel" style={{ height: 10, width: "60%", marginTop: 6 }} />
            <div className="sd-skel" style={{ height: 12, width: "42%", marginTop: 10 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

function ProductCard({ item, addProductImage, languageCode }) {
  const { t } = useTranslation();
  return (
    <Link
      className="sd-card-link"
      to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(
        item?.id,
        item?.pid,
        item?.store_id
      )}/${productTitle(item?.title)}?country=${item?.country}`}
      onClick={() => addProductImage(item?.image)}
    >
      <div className="sd-card">
        {item?.prices?.deal_value && (
          <div className="sd-flash-badge">
            <FlashOnIcon style={{ fontSize: "0.75rem" }} />
          </div>
        )}

        <div className="sd-img-wrap">
          <LazyLoadImage
            alt={item?.title}
            effect="blur"
            src={item?.image}
            onError={handleImgError}
            wrapperStyle={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
          <div className="sd-fast-delivery">
            <span>
              <BoltOutlinedIcon style={{ fontSize: "0.7rem", color: "#fe7f4a" }} />
              Fast Delivery
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="sd-card-body">
          <h3 className="sd-card-title">{item?.title?.replace(/[^\w\s.,'/:]/gi, " ")}</h3>

          <div className="sd-meta">
            {item?.brand && <span className="sd-brand">{item?.brand}</span>}
            {ratingFucn(item?.rating) && (
              <span className="sd-rating">
                {item?.rating}
                <GradeIcon style={{ fontSize: "0.65rem", color: "#fe7f4a" }} />
              </span>
            )}
          </div>

          <div className="sd-price-row">
            {Number(item?.prices?.value) === 0 ? (
              <span
                style={{
                  fontSize: "0.7rem",
                  background: "#f0f0f0",
                  color: "#666",
                  padding: "2px 7px",
                  borderRadius: 4,
                }}
              >
                Check Price
              </span>
            ) : (
              <>
                <span className="sd-deal-price">{formatPrice(item?.prices?.value, item?.prices?.currency, 0)}</span>
                {item?.prices?.deal_value && (
                  <span className="sd-orig-price">{formatPrice(item?.prices?.price, item?.prices?.currency, 0)}</span>
                )}
              </>
            )}
          </div>

          <div className="sd-origin">
            <span className="sd-from">{t("From") || "From"}</span>
            <img
              className="sd-flag"
              loading="lazy"
              src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
              srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
              alt=""
            />
            <span className="sd-from">{ProductCountries(item?.country)}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}

function StoreDeals() {
  const { userId, userToken, languageCode, countryCode } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { query } = useParams();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();

  const search = new URLSearchParams(location.search).get("search") || null;
  const searchCountry = new URLSearchParams(location.search).get("country") || null;
  const searchbrand = new URLSearchParams(location.search).get("brand") || null;
  const limit = new URLSearchParams(location.search).get("size") || 48;

  const thisSearch = search ? `&search=${search}` : "";
  const thisCountry = searchCountry ? `&search_country=${searchCountry}` : "";
  const thisBrand = searchbrand ? `&brand=${searchbrand}` : "";

  const [getProducts, setProductsData] = useState([]);
  const [getPage, setPage] = useState(1);
  const [getSearchId, setSearchId] = useState(0);
  const [getNextCursor, setNextCursor] = useState(0);

  const {
    data: newPosts = [],
    isLoading,
    isFetching,
  } = useGetStoreDealsQuery(
    {
      page: getPage,
      size: limit,
      nextCursor: `&nextCursor=${getNextCursor}`,
      query,
      search: thisSearch,
      search_id: `&search_id=${getSearchId}`,
      countryCode,
      searchCountry: thisCountry,
      searchBrand: thisBrand,
    },
    { count: 1, refetchOnMountOrArgChange: true }
  );

  const products = newPosts?.results;
  const pagination = newPosts?.pagination;

  useEffect(() => {
    if (products?.length > 0) setProductsData((prev) => [...prev, ...products]);
  }, [newPosts]);

  useEffect(() => {
    if (products) {
      setProductsData([...products]);
      setPage(1);
    }
  }, [query, search, searchCountry]);

  useEffect(() => {
    if (getPage === 1 && products) setProductsData([...products]);
  }, [getPage, products]);

  useEffect(() => {
    if (getPage === 1 && isFetching) setProductsData([]);
  }, [getPage, query, search, searchCountry]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  function addProductImage(data) {
    dispatch(addProductImg({ productImg: data }));
  }

  function loadMore() {
    setPage((p) => p + 1);
    setSearchId(getProducts?.slice(-1)[0]?.id || 0);
    setNextCursor(pagination?.nextCursor);
  }

  function searchOrder(data) {
    history.push(`${window.location.pathname}?search=${data.orderId}`);
  }
  function clearSearch() {
    reset2();
    history.push(window.location.pathname);
  }

  const isLoadingFirst = isLoading && getProducts.length === 0;
  const canLoadMore = !isFetching && !!pagination?.nextCursor;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{`Warehouse Deals | ${Host?.metaTitle}`}</title>
      </Helmet>

      <div className="sd-wrap container">
        <style>{STYLES}</style>

        <div className="sd-page-header">
          <div
            className="sd-page-title"
            style={{
              fontSize: "0.9rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: "rgb(107, 107, 107)",
            }}
          >
            <FlashOnIcon style={{ color: "#fe7f4a", fontSize: "1.35rem" }} />
            Warehouse Deals
            {isFetching && (
              <span
                style={{
                  display: "inline-block",
                  width: 16,
                  height: 16,
                  border: "2px solid #e0e0e0",
                  borderTopColor: "#1a73e8",
                  borderRadius: "50%",
                  animation: "sd-spin 0.7s linear infinite",
                  marginLeft: 4,
                }}
              />
            )}
          </div>

          <form className="sd-search-box" onSubmit={handleSubmit2(searchOrder)}>
            <input
              className="sd-search-input"
              defaultValue={search}
              type="text"
              placeholder="Search in deals…"
              id="orderId"
              {...register2("orderId", { required: true })}
            />
            {!search ? (
              <button className="sd-search-btn" type="submit">
                <SearchIcon style={{ fontSize: "1.2rem" }} />
              </button>
            ) : (
              <button className="sd-search-btn" type="button" onClick={clearSearch}>
                <CloseIcon style={{ fontSize: "1.2rem" }} />
              </button>
            )}
          </form>
        </div>

        <div className="sd-layout">
          <main className="sd-main">
            {isLoadingFirst ? (
              <SkeletonGrid count={8} />
            ) : getProducts.length === 0 && !isFetching ? (
              <div className="sd-empty">
                <ErrorOutlineOutlinedIcon />
                <p>Couldn't find what you're looking for. Try a different search or filter.</p>
              </div>
            ) : (
              <>
                <div className="sd-grid">
                  {getProducts.map((item, i) => (
                    <ProductCard
                      key={item.id || i}
                      item={item}
                      addProductImage={addProductImage}
                      languageCode={languageCode}
                    />
                  ))}
                </div>

                {isFetching && getProducts.length > 0 && (
                  <div className="sd-grid" style={{ marginTop: 13 }}>
                    <SkeletonGrid count={4} />
                  </div>
                )}

                {getProducts.length > 0 && (
                  <div className="sd-load-more-wrap">
                    <button className="sd-load-more-btn" disabled={!canLoadMore} onClick={loadMore}>
                      {isFetching ? (
                        <>
                          <span
                            style={{
                              display: "inline-block",
                              width: 14,
                              height: 14,
                              border: "2px solid #ddd",
                              borderTopColor: "#333",
                              borderRadius: "50%",
                              animation: "sd-spin 0.7s linear infinite",
                            }}
                          />
                          Loading…
                        </>
                      ) : canLoadMore ? (
                        t("load_more") || "Load more"
                      ) : (
                        "All caught up"
                      )}
                    </button>
                  </div>
                )}
              </>
            )}
          </main>
        </div>
      </div>
      <br />
      <br />
      <style>{`@keyframes sd-spin { to { transform: rotate(360deg); } }`}</style>
    </>
  );
}

export default StoreDeals;
